/*=========================================================================================
  File Name: module-dictionary.js
  Description: Dictionary Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-dictionary-state';
import mutations from './module-dictionary-mutations';
import actions from './module-dictionary-actions';
import getters from './module-dictionary-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
